export default __webpack_public_path__ + "static/media/hurricane.2c2aca7f.png";